module.exports = __webpack_public_path__ + "static/media/banner2.1e603e5a.jpg";